export const priceFormat = (x) => x?.toLocaleString('es-MX');